import type {JSONObject, UserId} from 'types/common';
import {doc, FirestoreDataConverter} from 'firebase/firestore';
import {firestore as db} from 'firebaseApp';
import 'firebase/compat/firestore';
import firebase from 'firebase/compat/app';
import {arrayUnion} from 'firebase/firestore';
export interface TipTapDocument {
  content: JSONObject;
  lastEdit: Date;
  version: 'V2' | string;
  editors: UserId[];
  ydoc: firebase.firestore.Blob;
}

const tipTapDocumentConverter: FirestoreDataConverter<TipTapDocument> = {
  toFirestore: (tipTapDocument: TipTapDocument) => {
    return {...tipTapDocument, editors: arrayUnion(tipTapDocument.editors)};
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return data as TipTapDocument;
  },
};

export function getTipTapDocumentRef(path: string) {
  return doc(db, path).withConverter(tipTapDocumentConverter);
}
